import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { workflowDetailDtoSchema } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

export function useWorkflow(workflowId: string | undefined) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: workflowKeys.detail(workflowId ?? ''),
    queryFn: async ({ signal }) => {
      const raw = await apiClient
        .get(`api/v1/t/${tenantId}/workflows/${workflowId}`, { signal })
        .json();
      return workflowDetailDtoSchema.parse(raw);
    },
    enabled: !!tenantId && !!workflowId,
  });
}
